/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { GenerateReferralLetterPdfErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const generateReferralLetterPdf = (encounterId: number, signal?: AbortSignal) => {
  return api<Blob>({
    url: `/api/encounters/${encounterId}/referral-letter-pdf`,
    method: 'POST',
    responseType: 'blob',
    signal,
  });
};

export const getGenerateReferralLetterPdfMutationOptions = <
  TError = GenerateReferralLetterPdfErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReferralLetterPdf>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateReferralLetterPdf>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['generateReferralLetterPdf'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateReferralLetterPdf>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return generateReferralLetterPdf(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateReferralLetterPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateReferralLetterPdf>>
>;

export type GenerateReferralLetterPdfMutationError = GenerateReferralLetterPdfErrorResponse;

export const useGenerateReferralLetterPdf = <
  TError = GenerateReferralLetterPdfErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateReferralLetterPdf>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateReferralLetterPdf>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions = getGenerateReferralLetterPdfMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
